export const selectStyles = {
  control: (baseStyles) => ({
    ...baseStyles,
    height: 40,
  }),
};
